import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DestinationSearchParams } from '../../params/destination-search.params';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { FieldsBasicPlaceDetails } from '../../../../../shared/consts/fields-basic-place-details';

@Component({
    selector: 'app-destination-filter',
    templateUrl: './destination-filter.component.html',
    styleUrls: ['./destination-filter.component.css'],
})
export class DestinationFilterComponent implements OnInit {
    @Output() onSearch = new EventEmitter<DestinationSearchParams>();
    @Input() filter: DestinationSearchParams;
    googlePlace?: Address;
    readonly options = {
        fields: FieldsBasicPlaceDetails,
    };

    readonly formGroup = new FormGroup({
        state: new FormControl(''),
        googlePlaceString: new FormControl(''),
        googlePlaceId: new FormControl(''),
    });

    constructor() {}

    ngOnChanges() {
        this.formGroup.patchValue(this.filter || {});
    }

    handleAddressChangeOfCity(address: Address) {
        this.googlePlace = address;
        this.formGroup.patchValue({
            googlePlaceId: address ? address.place_id : undefined,
        });
    }
    onKeyUp(evt: KeyboardEvent) {
        // check if backspace or delete key is pressed
        if (evt.key === 'Backspace') {
            // if there is a selected google place, clear the input field
            if (this.googlePlace) {
                this.formGroup.patchValue({
                    googlePlaceString: undefined,
                });
            }
        }
        this.googlePlace = undefined;
        this.formGroup.patchValue({
            googlePlaceId: undefined,
        });
    }

    ngOnInit() {}

    submit() {
        this.onSearch.emit(this.formValue);
    }

    get formValue() {
        const obj = this.formGroup.value;

        const result = {} as any;

        for (const [key, value] of Object.entries(obj)) {
            if (value) {
                result[key] = value;
            }
        }

        return result;
    }
}
